import { GetFormEntriesModel, GetReviewsModel } from 'fourwaves-shared';

export interface SendMessageModel {
  subject: string;
  body: string;
  fileUploadId: string | null;
  query?: GetFormEntriesModel | GetReviewsModel | null;
  recipientTypes: RecipientType[];
}

export enum RecipientType {
  Owners = 'owners',
  Authors = 'authors',
  Presenters = 'presenters',
}
